<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="16"
        viewBox="0 0 20 16"
        fill="none"
    >
        <path
            d="M19.5819 3.15497C19.3519 2.28872 18.6744 1.60685 17.8138 1.37497C16.2537 0.954346 10 0.954346 10 0.954346C10 0.954346 3.74562 0.954346 2.18625 1.37497C1.32562 1.60622 0.648125 2.28872 0.418125 3.15497C0 4.72497 0 7.99997 0 7.99997C0 7.99997 0 11.2756 0.418125 12.845C0.648125 13.7112 1.32562 14.3931 2.18625 14.6243C3.74625 15.045 10 15.045 10 15.045C10 15.045 16.2544 15.045 17.8138 14.6243C18.6744 14.3931 19.3519 13.7106 19.5819 12.845C20 11.275 20 7.99997 20 7.99997C20 7.99997 20 4.72497 19.5819 3.15497ZM7.95438 10.9737V5.02622L13.1819 7.99997L7.95438 10.9737Z"
            fill="#FF0000"
        />
    </svg>
</template>
